import { observer } from 'mobx-react';

import { TabList } from '../../../app/shared/components/TabList/TabList';
import PricelistListing from '../PricelistListing/PricelistListing';
import ProductListing from '../ProductListing/ProductListing';
import css from './Pricelists.css';
import PricelistsState, { TAB_IDS } from './PricelistsState';

interface PricelistsProps {
  state: PricelistsState;
}

const Pricelists = observer(({ state }: PricelistsProps) => {
  return (
    <div>
      <TabList
        className={css.tabList}
        tabItemClassName={css.tabItem}
        tabs={state.tabs.tabs}
        setActiveTab={state.tabs.setActiveTab}
      />
      <Tabs state={state} />
    </div>
  );
});

export default Pricelists;

interface TabsProps {
  state: PricelistsState;
}

const Tabs = observer(({ state }: TabsProps) => {
  switch (state.tabs.activeTab.id) {
    case TAB_IDS.Products:
      return <ProductListing state={state.productListing} />;
    case TAB_IDS.Pricelists:
      return <PricelistListing state={state.pricelistListing} />;
    default:
      return null;
  }
});
